<template>
  <el-dialog :visible.sync="visible" :title="title" width="900px">
    <div class="view-detail">
      <div class="detail-item" :class="{ 'full-width': item.type === 'fullWidth' }" v-for="item in items" :key="item.prop">
        <div class="label">{{ item.label }}：</div>
        <div class="value">{{ info[item.prop] }}</div>
      </div>
      <div class="detail-item full-width">
        <div class="label">附件：</div>
        <div class="value">
          <new-table class="file-table" :data="info.attachList" :columns="fileColumns"></new-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import NewTable from "@/components/new-table";
export default {
  name: "view-detail",
  props: {
    items: Array,
    title: { type: String, default: "查看详情" },
  },
  data() {
    return {
      visible: false,
      info: {},
      fileColumns: [
        { label: "文件名称", prop: "fileName" },
        { label: "上传人", prop: "uploadUserName" },
        { label: "上传时间", prop: "creationTime" },
        {
          label: "操作",
          width: "100px",
          render: (h, { row }) => (
            <span>
              <el-button type="text" onClick={() => this.download(row)}>
                下载
              </el-button>
            </span>
          ),
        },
      ],
    };
  },
  methods: {
    show(info) {
      this.info = info;
      this.visible = true;
    },
    download(row) {
      window.open(`${this.$ossUrl}${row.filePath}`);
    },
  },
  components: { NewTable },
};
</script>
